import styled from 'styled-components'
import { theme } from './../../common'
import { Row } from 'react-bootstrap'

export const StyledTitle = styled.h1`
    font-size: 3em;
    font-weight: bold;
    /* margin-bottom: 2%; */
    @media screen and (max-width: 992px) {
        font-size: 2em;
    }
`

export const StyledRow = styled(Row)`
    background-color: ${theme.lightGrey};
    height: 320px;
`